<!-- VerticalTabs.vue -->
<template>
  <div class="vertical-tabs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VerticalTabs',
}
</script>

<style lang="scss" scoped>
.vertical-tabs {
  width: 100%;
  color: #282E3E;
}
</style>
